import * as React from 'react';
import * as what from "./style.module.scss";
export const What = () => {
  return (
    <section className={what.what}>
      <div className="container">
        <h2>Из чего состоит курс?</h2>
        <p>- пошаговый алгоритм быстрого запоминания иностранных слов</p>
        <p>- упражнения на&nbsp;отработку навыков запоминания</p>
        <p>- упражнения для&nbsp;повторения изученных слов</p>
      </div>
    </section>
  );
};
